import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-invalid-modelations-dialog',
    templateUrl: './too-many-requests-dialog.component.html',
    imports: [MatDialogModule, MatButtonModule],
})
export class TooManyRequestsDialogComponent {
    dialogRef = inject<MatDialogRef<TooManyRequestsDialogComponent>>(MatDialogRef);
}
